import request from '@/utils/request'

//新增客户数据
export  function SaveCooperation(data){
    return request({
        url:'/oa_ows/oa/ows/Cooperation/SaveCooperation',
        method:'Post',
        data:data,
        timeout: 50000
    })
}